import { z } from 'my-zod'
import { customerOrderChangeLogModel } from './customer-order-change-log-entry-model'

export const customerOrderChangeLogSystemView = customerOrderChangeLogModel.augment({
  change: z
    .object({
      description: z.string()
    })
    .nullable(),
  authorName: z.string().nullish()
})
export type customerOrderChangeLogSystemView = z.infer<typeof customerOrderChangeLogSystemView>
